import { Props_SnippetQuote } from "./Quote.props";

export const SnippetQuote = (props: Props_SnippetQuote) => {
    const { headingProps, quote } = props;
    const titleVisibilityClass = headingProps.visibility.value === 'true' ? "snippet-quote__title" : "snippet-quote__title accessible-heading";
    return (
        <section className="snippet-quote">
            <blockquote className="snippet-quote__blockquote">
                <h2 className={titleVisibilityClass}>{headingProps.heading.value}</h2>
                <p className="snippet-quote__text">{quote.content?.value}</p>
            </blockquote>
        </section>
    );
}